/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { encode, decode } from 'gpt-tokenizer'
import { useMemo } from 'react'
import {pageConfig} from "~/config/_pages/tools/tokenizer"

export type TokenSegment = {
  token: number
  text: string
  start: number
  end: number
}

export type TokenAnalysis = {
  tokens: number[]
  segments: TokenSegment[]
  cost: number
  error: string | null
}

const PRICE_PER_MILLION_TOKENS = Number(pageConfig.price_per_million_token)

export function analysePrompt(prompt: string) {
  const tokens = encode(prompt)
  let offset = 0
  const segments: TokenSegment[] = tokens.map((token) => {
    const decoded = decode([token])
    const length = decoded.length
    const segment = {
      token,
      text: decoded,
      start: offset,
      end: offset + length,
    }
    offset += length
    return segment
  })
  return { tokens, segments }
}

export function useTokenAnalysis(prompt: string): TokenAnalysis {
  return useMemo(() => {
    if (!prompt) {
      return { tokens: [], segments: [], cost: 0, error: null }
    }
    
    try {
      const { tokens, segments } = analysePrompt(prompt)
      const cost = (tokens.length / 1000000) * PRICE_PER_MILLION_TOKENS
      
      return { tokens, segments, cost, error: null }
    } catch (error) {
      console.error('Encoding failed', error)
      return {
        tokens: [],
        segments: [],
        cost: 0,
        error: 'خطا در پردازش متن.',
      }
    }
  }, [prompt])
}